<wd-input-container [name]="name" [classes]="classes()" [label]="label" [helpText]="helpText()" [comments]="comments" [hideComments]="hideComments">
	<select
		[name]="'input' + name"
		type="text"
		class="form-control"
		[(ngModel)]="model"
		#inputValue="ngModel"
		[ngClass]="classes()"
		[attr.tabindex]="disabled() ? -1 : 0"
		(mousedown)="onMouseDown($event)"
		(focus)="onFocus($event)"
		(focusout)="onFocusOut()"
		(ngModelChange)="onChange()"
		(click)="onClick($event)"
	>
	<option *ngIf="needsEmptyOption()" value=""></option>
	<option *ngIf="needsInvalidOption()" value="{{model}}">{{displayString(model)}}</option>
	<option *ngFor="let o of data" value="{{o}}"
		[disabled]="disabled()"
		[selected]="isSelected(o)">{{displayString(o)}}
	</option>
	</select>
</wd-input-container>
